export const TRAINING_CUSTOM_REMARKS_FIELD_NAME = "remarks";
